module.exports = __webpack_public_path__ + "./Matthew_pbw_41f2e5571416d213f689b16b917237bd.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/sectionTalking/2023/Matthew_pbw.png
// module id = 601
// module chunks = 0